import { z } from 'zod';
const FreeDailyBonusSuccessInboundSchema = z
    .object({
    numBaseChips: z.number(),
    numActivityChips: z.number(),
    numStreakChips: z.number(),
    powerPlayerAdditionalPercent: z.number(),
    numTotalChips: z.number(),
    freeDailyBonusSecondsLeft: z.number(),
    streak: z.number()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'free_daily_bonus_success',
    ...rest
}));
export const FREE_DAILY_BONUS_SUCCESS_PAYLOAD_DEFINITION = {
    zodSchema: FreeDailyBonusSuccessInboundSchema
};
